import React, { useState } from 'react';
import './Button.css';

/**
 * Refresh Icon SVG Component
 */
const RefreshIcon = ({ size = 16 }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2" 
    strokeLinecap="round" 
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <polyline points="23 4 23 10 17 10"></polyline>
    <polyline points="1 20 1 14 7 14"></polyline>
    <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
  </svg>
);

/**
 * RefreshButton Component
 * Button specifically styled for refresh/reload actions with spinning animation
 * 
 * @param {function} onClick - Click handler
 * @param {string} size - Button size: 'small'|'medium'|'large' (default: 'medium')
 * @param {boolean} disabled - Disabled state
 * @param {string} className - Additional CSS classes
 */
const RefreshButton = ({ 
  onClick, 
  size = 'medium', 
  disabled = false, 
  className = '' 
}) => {
  const [isSpinning, setIsSpinning] = useState(false);
  
  const iconSize = size === 'large' ? 18 : size === 'small' ? 14 : 16;
  
  const handleClick = (e) => {
    if (disabled) return;
    
    // Start spinning animation
    setIsSpinning(true);
    
    // Call the original onClick handler
    if (onClick) {
      onClick(e);
    }
    
    // Stop spinning after 1 second
    setTimeout(() => {
      setIsSpinning(false);
    }, 1000);
  };
  
  return (
    <button
      className={`btn-refresh ${isSpinning ? 'spinning' : ''} ${className}`.trim()}
      onClick={handleClick}
      disabled={disabled}
      aria-label="Refresh"
    >
      <RefreshIcon size={iconSize} />
    </button>
  );
};

export default RefreshButton;

